import { render, staticRenderFns } from "./studentComment.vue?vue&type=template&id=371bf71a&scoped=true"
import script from "./studentComment.vue?vue&type=script&lang=js"
export * from "./studentComment.vue?vue&type=script&lang=js"
import style0 from "./studentComment.vue?vue&type=style&index=0&id=371bf71a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371bf71a",
  null
  
)

export default component.exports